import { RouteConfig } from 'vue-router';

import { EntityType } from '@/enums/entityType.enum';
import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';
import { tryParseInt } from '@/utils/number';

export const stageOptionsRoute: RouteConfig = {
  path: ':stageId/options',
  name: 'stageOptions',
  component: () => import(/* webpackChunkName: "StageOptions" */ '@/views/mainRoute/stage/Options.vue'),
  meta: {
    breadcrumb: {
      title: 'Opcje Etapu'
    }
  },
  beforeEnter: (to, from, next) => {
    store
      .dispatch('stage/get', tryParseInt(to.params.stageId))
      .then(() => {
        Promise.all([
          store.dispatch('option/list', {
            entityId: store.state.stage.data.moduleId.toString(),
            entityType: EntityType.MODULE
          }),
          store.dispatch('optionValue/list', {
            entityId: to.params.stageId.toString(),
            entityType: EntityType.STAGE
          })
        ]);
      })
      .then(() => next())
      .catch((err: any) => store.dispatch('notifyError', { title: Errors.STAGE_CANNOT_LIST_OPTIONS }));
  }
};
